import { render } from "./SemesterDetails.vue?vue&type=template&id=37c77cef&scoped=true"
import script from "./SemesterDetails.vue?vue&type=script&lang=js"
export * from "./SemesterDetails.vue?vue&type=script&lang=js"

import "./SemesterDetails.vue?vue&type=style&index=0&id=37c77cef&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c77cef"]])

export default __exports__